import { RecentlyViewed } from '@theme/recently-viewed-products';

const SECTION_TYPE = 'recently-viewed-products';

/**
 * Build a Shopify search query that fetches products by numeric id:
 * id:123 OR id:456
 * @param {string[]} ids
 */
function buildIdQuery(ids) {
  return ids.map((id) => `id:${id}`).join(' OR ');
}

/**
 * @param {string | number | null | undefined} id
 */
function normalizeId(id) {
  if (id === null || id === undefined) return null;
  const s = String(id).trim();
  return s.length ? s : null;
}

class RecentlyViewedProductsElement extends HTMLElement {
  #abortController;

  connectedCallback() {
    if (this.dataset.sectionType !== SECTION_TYPE) return;
    if (this.hasAttribute('data-initialized')) return;
    this.setAttribute('data-initialized', 'true');

    this.#render();
  }

  disconnectedCallback() {
    this.#abortController?.abort();
  }

  async #render() {
    const sectionId = this.dataset.sectionId;
    if (!sectionId) return;

    const limit = Number(this.dataset.limit || '4') || 4;
    const currentProductId = normalizeId(this.dataset.currentProductId);

    // localStorage list is most-recent-first and includes the current PDP product.
    let ids = RecentlyViewed.getProducts().map(normalizeId).filter(Boolean);

    if (currentProductId) {
      ids = ids.filter((id) => id !== currentProductId);
    }

    ids = ids.slice(0, limit);
    if (ids.length === 0) return;

    const query = buildIdQuery(ids);

    const url = new URL(window.location.href);
    url.pathname = '/search';
    url.searchParams.set('type', 'product');
    url.searchParams.set('q', query);
    url.searchParams.set('section_id', sectionId);

    this.#abortController = new AbortController();

    let html = '';
    try {
      const res = await fetch(url.toString(), {
        signal: this.#abortController.signal,
        headers: { 'X-Requested-With': 'XMLHttpRequest' },
      });
      if (!res.ok) return;
      html = await res.text();
    } catch {
      return;
    }

    const doc = new DOMParser().parseFromString(html, 'text/html');
    const incoming = doc.querySelector('recently-viewed-products');
    if (!incoming) return;

    // Replace our shell with server-rendered content.
    this.innerHTML = incoming.innerHTML;
  }
}

if (!customElements.get('recently-viewed-products')) {
  customElements.define('recently-viewed-products', RecentlyViewedProductsElement);
}

